/**
 * 기본적으로 사용하는 사용자 권한을 정의한 enum
 */
export enum UserRole {
  ROLE_MASTER_ADMIN = 'ROLE_MASTER_ADMIN',
  ROLE_SITE_ADMIN = 'ROLE_SITE_ADMIN',
  ROLE_CONSTRUCTOR = 'ROLE_CONSTRUCTOR',
  ROLE_SUB_CONSTRUCTOR = 'ROLE_SUB_CONSTRUCTOR',
  ROLE_WORKER = 'ROLE_WORKER'
}

export const UserRoleType: { [key: string]: string } = {
  ROLE_MASTER_ADMIN: 'ROLE_MASTER_ADMIN',
  ROLE_SITE_ADMIN: 'ROLE_SITE_ADMIN',
  ROLE_CONSTRUCTOR: 'ROLE_CONSTRUCTOR',
  ROLE_SUB_CONSTRUCTOR: 'ROLE_SUB_CONSTRUCTOR',
  ROLE_WORKER: 'ROLE_WORKER'
};

export const getUserRole = () => Object.keys(UserRole);

export const checkUserRole = (role: string): boolean => {
  if (!role || !getUserRole().includes(role)) return false;

  return true;
};

/**
 * 기본적으로 사용하는 사용자 권한을 정의한 enum (ROLE_ 제외)
 */
export enum AccessLevel {
  MASTER_ADMIN = 'MASTER_ADMIN',
  SITE_ADMIN = 'SITE_ADMIN',
  CONSTRUCTOR = 'CONSTRUCTOR',
  SUB_CONSTRUCTOR = 'SUB_CONSTRUCTOR',
  WORKER = 'WORKER'
}

export const AccessLevelType: { [key: string]: string } = {
  MASTER_ADMIN: 'MASTER_ADMIN',
  SITE_ADMIN: 'SITE_ADMIN',
  CONSTRUCTOR: 'CONSTRUCTOR',
  SUB_CONSTRUCTOR: 'SUB_CONSTRUCTOR',
  WORKER: 'WORKER'
};

export const getAccessLevel = () => Object.keys(AccessLevel);

export const checkAccessLevel = (role: string): boolean => {
  if (!role || !getAccessLevel().includes(role)) return false;

  return true;
};

// ROLE_ADMIN -> ROLE_MASTER_ADMIN
// ROLE_EPC -> ROLE_SITE_ADMIN
// ROLE_CLIENT -> ROLE_CONSTRUCTOR
// ROLE_VENDOR -> ROLE_SUB_CONSTRUCTOR
// ROLE_WORKER -> ROLE_WORKER
